
export const removeToken = () => {
  localStorage.removeItem('token');
};
